// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiServerUrl: 'https://api-stgnew.casherpay.com/',
  plaid_public_key: 'fa766a9f3eea574e9f396658b3aaa6',
  captcha_key: '6LfTx9MlAAAAAKe_2ENyVm81FeUDkOX9dadHYzrF',
  APIKey: 'casherpaykey',
  APIPassword: 'r348lo3984husdadi3h869584',
  frotendUrl: 'https://portal-stgnew.casherpay.com/#/'
};



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/environments/environment.ts